export default "__VITE_ASSET__D1d9Ga7q__"